import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

export default function ListSubject() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const animatedComponents = makeAnimated();
  const navigate = useNavigate();
  const location = useLocation();
  const { examId, subjectId, subjectName } = location.state || {};
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [rollNumbers, setRollNumbers] = useState([]);
  const [loadingRollNumbers, setLoadingRollNumbers] = useState(false);
  const [formData, setFormData] = useState({
    rollNumbers: [],
  });
  const [facultyList, setFacultyList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleClearRows, setToggleClearRows] = useState(false);
  const [rowFacultyAssignments, setRowFacultyAssignments] = useState({});

  const [selectedFacultyRowId, setSelectedFacultyRowId] = useState(null);
  const [rowReAssFacultyId, setRowReAssFacultyId] = useState(null); // Track re-assessment faculty ID
  const [additionalFacultyId, setAdditionalFacultyId] = useState(''); // Track additional faculty ID
  const [facultyData, setFacultyData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    fetchRecords();
    fetchFacultyList();
  }, []);

  useEffect(() => {
    const modal = document.getElementById('staticBackdrop');
    const handleModalClose = () => {
      resetFormData();
    };
    modal.addEventListener('hidden.bs.modal', handleModalClose);

    return () => {
      modal.removeEventListener('hidden.bs.modal', handleModalClose);
    };
  }, []);

  const fetchRecords = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');

    const data = {
      examId: examId,
      subjectId: subjectId,
    };

    try {
      const response = await axios.post(
        `${apiUrl}/api/reAssessment/faculty/details/list`,
        data,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
          maxBodyLength: Infinity,
        }
      );

      // Initialize rowFacultyAssignments with reAssfacultyId
      const assignments = response.data.students.reduce((acc, student) => {
        acc[student.id] = student.reAssfacultyId;
        return acc;
      }, {});

      setRecords(response.data.students);
      setRowFacultyAssignments(assignments);
      setLoading(false);
      setCount(response.data.totalStudents);
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error('Error fetching records:', error);
      setLoading(false);
    }
  };

  // Function to fetch roll numbers for the selected exam
  const fetchRollNumbers = () => {
    setLoadingRollNumbers(true);
    const token = localStorage.getItem('token');

    axios
      .post(
        `${apiUrl}/api/students/rollnumber/list`,
        JSON.stringify({ examId }),
        {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
          },
        }
      )
      .then((res) => {
        const rollNumbersData = res.data.students || [];
        setRollNumbers(rollNumbersData);
        setLoadingRollNumbers(false);
      })
      .catch((err) => {
        err.response?.status === 401 && navigate('/');
        console.error('Error fetching roll numbers:', err);
        setLoadingRollNumbers(false);
      });
  };

  // function to fetch faculty list for the selected
  const fetchFacultyList = async () => {
    const token = localStorage.getItem('token');
    try {
      let data = JSON.stringify({
        subjectId: subjectId,
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/faculty/list-faculty`,
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
        data: data,
      };

      const response = await axios.request(config);

      // Setting faculties from the response, assuming 'faculties' is the key
      setFacultyList(response.data.faculties || []);
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error('Error fetching faculty list:', error);
      setFacultyList([]); // Fallback to empty array in case of error
    }
  };
  const handleChange = (selectedOptions, actionMeta) => {
    if (actionMeta.name === 'rollNumbers') {
      const ids = selectedOptions
        ? selectedOptions.map((option) => option.value)
        : [];
      setFormData((prevState) => ({
        ...prevState,
        [actionMeta.name]: ids,
      }));
    } else {
      const { name, value } = actionMeta;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const rollNumberOptions = rollNumbers.map((rollNumber) => ({
    value: rollNumber.rollNumber, // Adjust based on the actual structure of `rollNumbers`
    label: rollNumber.rollNumber,
  }));

  const columns = [
    {
      name: 'Status',
      selector: (row) => row.status,
      sortable: true,
      center: 'true',
      width: '80px',
      cell: (row) =>
        row.status ? (
          <span style={{ color: 'green', fontSize: '20px' }}>✔️</span>
        ) : (
          <span style={{ color: 'red', fontSize: '20px' }}>❌</span>
        ),
    },

    {
      name: 'No',
      selector: (row, index) => {
        // Calculate serial number based on current page and rows per page
        return (currentPage - 1) * rowsPerPage + index + 1;
      },
      width: '50px',
      center: 'true',
    },
    {
      name: 'Roll Number',
      selector: (row) => row.rollNumber,
      sortable: true,
      width: '120px',
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Old Allocated',
      selector: (row) => row.facultys.map((faculty) => faculty.name).join(', '),
      sortable: true,
    },
    {
      name: 'Assign Reassessment',
      width: '200px',
      center: 'true',
      cell: (row) => (
        <div className="col-md-8">
          <select
            className="form-select form-select-sm"
            value={rowFacultyAssignments[row.id] || ''}
            onChange={(e) => handleFacultyChange(row.id, e.target.value)}
          >
            <option value="">Select Faculty</option>
            {Array.isArray(facultyList) && facultyList.length > 0 ? (
              facultyList.map((faculty) => (
                <option key={faculty.facultyId} value={faculty.facultyId}>
                  {faculty.facultyName}
                </option>
              ))
            ) : (
              <option>No faculty available</option>
            )}
          </select>
        </div>
      ),
    },
    {
      name: 'Re-Reassessment',
      width: '140px',
      center: 'true',
      cell: (row) => (
        <div className="col-md-12 text-center">
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            className="btn btn-primary btn-sm   px-1 "
            hidden={row.authorised}
            onClick={() => handleEditButtonClick(row.id, row.reAssfacultyId)} // Pass row.id and row.reAssfacultyId
          >
            Reassessment
          </button>
        </div>
      ),
    },
    {
      name: 'Actions',
      width: '115px',
      center: 'true',
      cell: (row) => (
        <div>
          <button
            className="btn btn-outline-danger btn-sm mx-2 "
            onClick={() => deleteRecord(row.id)}
            data-tooltip-id="my-tooltip"
            data-tooltip-content=" Delete Reassessment"
          >
            <i className="bi bi-trash3-fill"></i>
          </button>
          <button
            onClick={() => facultyButtonClick(row.barcodeNo, row)}
            data-bs-toggle="modal"
            data-bs-target="#facultyModal"
            className="btn btn-primary btn-sm"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="View Faculty Details"
          >
            <i className="bi bi-journal-richtext"></i>
          </button>
        </div>
      ),
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.isManualMark,
      style: {
        color: 'red',
      },
    },
  ];

  const facultyButtonClick = async (barcodeNo, row) => {
    setSelectedRow(row); // Store the entire row data in state
    console.log(row);

    try {
      const token = localStorage.getItem('token');
      let data = JSON.stringify({ barcodeNo: barcodeNo });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/qrCode/faculty/detail?allocationType=REASSESSMENT`,
        headers: {
          Authorization: `${token}`, // Ensure token format is correct (e.g., Bearer token if required)
          'Content-Type': 'application/json',
        },
        data: data,
      };

      const response = await axios.request(config);
      setFacultyData(response.data); // Set API response data in state
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error('Error fetching data:', error);
    }
  };
  const handleImageClick = (facultyId) => {
    closemodelfs();

    // Encode the barcode in base64 using btoa
    const encodedBarcode = btoa(selectedRow.barcodeNo || '');

    // Navigate with the encoded barcode and other data in the state
    navigate('/ViewAnswerSheet', {
      state: {
        facultyId,
        id: examId,
        subjectId,
        barcode: encodedBarcode, // Pass encoded barcode
        barcodeId: selectedRow.qrCodeId,
        allocationType: 'REASSESSMENT',
        userType: 'admin',
        StaTus: 'COMPLETED',
      },
    });
  };

  // ------------------ close model after submit----------------------
  const closemodelfs = () => {
    const closeButton = document.querySelector('#facultyModal .btn-close');
    if (closeButton) {
      closeButton.click();
    }
  };

  const handleEditButtonClick = (rowId, reAssfacultyId) => {
    setSelectedFacultyRowId(rowId); // Store the selected row ID
    setRowReAssFacultyId(reAssfacultyId); // Store re-assessment faculty ID
    setAdditionalFacultyId(''); // Reset additional faculty selection when modal opens
  };

  const closeReassessmentModal = () => {
    const closeButton = document.querySelector('#exampleModal .btn-close');
    if (closeButton) {
      closeButton.click();
    }
  };
  const ReReassessment = async () => {
    const updateData = [
      {
        id: selectedFacultyRowId, // The ID of the selected row
        reAssfacultyId: rowReAssFacultyId, // The selected re-assessment faculty ID
        additionalFacultyId: parseInt(additionalFacultyId), // The selected additional faculty ID
      },
    ];
    const data = JSON.stringify({
      examId: examId, // Replace with the actual examId
      subjectId: subjectId, // Replace with the actual subjectId
      updateData: updateData,
    });
    const token = localStorage.getItem('token');
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/reAssessment`,
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
      data: data,
    };
    try {
      const response = await axios.request(config);

      toast.success(response.data.message);
      closeReassessmentModal();
      fetchRecords();
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error(error);
      toast.error(error.response.data.error || error.response.data.message);
    }
  };

  const resetFormData = () => {
    setFormData({
      rollNumbers: [],
    });
  };

  const handleAddReassessment = async () => {
    const token = localStorage.getItem('token');
    const data = {
      examId: examId,
      subjectId: subjectId,
      rollNumbers: formData.rollNumbers,
    };
    try {
      const response = await axios.post(
        `${apiUrl}/api/reAssessment/faculty/details/list`,
        data,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (response.status === 200) {
        toast.success('Reassessment added successfully.');
        fetchRecords();
        closemodel();
      } else {
        toast.error('Failed to add reassessment.');
      }
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      toast.error(error.response.data.message);
    }
  };
  const closemodel = () => {
    const closeButton = document.querySelector('#staticBackdrop .btn-close');
    if (closeButton) {
      closeButton.click();
    }
  };
  // Store selected faculty in state
  const handleFacultyChange = (rowId, selectedFacultyId) => {
    setRowFacultyAssignments((prevAssignments) => ({
      ...prevAssignments,
      [rowId]: parseInt(selectedFacultyId), // Ensure the faculty ID is an integer
    }));
  };
  const handleSubmitFacultyAssignments = async () => {
    const token = localStorage.getItem('token');
    const updateData = records
      .filter((row) => rowFacultyAssignments[row.id])
      .map((row) => ({
        id: row.id,
        reAssfacultyId: rowFacultyAssignments[row.id],
      }));

    const data = {
      examId: examId,
      subjectId: subjectId,
      updateData: updateData,
    };

    try {
      const response = await axios.post(`${apiUrl}/api/reAssessment`, data, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
        maxBodyLength: Infinity,
      });

      if (response.status === 200) {
        toast.success('Reassessment faculty allocated successfully.');
        fetchRecords();
        setRowFacultyAssignments({}); // Clear assignments
        setToggleClearRows(!toggleClearRows);
      } else {
        toast.error('Failed to allocate reassessment faculty.');
      }
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error('Error allocating reassessment faculty:', error);
      toast.error('Error allocating reassessment faculty.');
    }
  };

  const deleteRecord = async (id) => {
    const token = localStorage.getItem('token');
    // Show confirmation dialog
    const isConfirmed = window.confirm(
      'Are you sure you want to delete this record?'
    );
    if (isConfirmed) {
      try {
        const response = await axios.request({
          method: 'DELETE',
          url: `${apiUrl}/api/reAssessment/${id}`,
          headers: {
            Authorization: token,
          },
          data: '', // Pass any required data or leave it empty
        });
        toast.success('Record deleted successfully.');
        fetchRecords();
      } catch (error) {
        error.response?.status === 401 && navigate('/');
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <div>
      <main id="main" className="main">
        <AdminLayout ac9="active">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <span className="cursor-pointer">
                    {' '}
                    <Link to="/ReasseDasboard">Reassessment Exams</Link>
                  </span>
                </li>
                <li className="breadcrumb-item " onClick={() => navigate(-1)}>
                  Reassessment subjects
                </li>

                <li className="breadcrumb-item active">
                  Reassessment list of {subjectName} ({count})
                </li>
              </ol>
            </nav>
          </div>
          <hr className="mb-0" />
          <div className="row">
            <div className="container">
              <div className="datatable-top">
                <div className="datatable-search">
                  <input
                    className="form-control"
                    type="search"
                    name="totalMarks"
                    placeholder="Search"
                    title="Search within table"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-primary "
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    onClick={fetchRollNumbers}
                    disabled={loadingRollNumbers}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Add Reassessment"
                  >
                    <i className="bi bi-plus-square"></i>
                  </button>
                </div>
              </div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={records}
                  progressPending={loading}
                  selectableRows
                  onSelectedRowsChange={(state) =>
                    setSelectedRows(state.selectedRows)
                  }
                  clearSelectedRows={toggleClearRows} // Clear selected rows when toggled
                  className="custom-table"
                  pagination
                  conditionalRowStyles={conditionalRowStyles}
                  paginationPerPage={rowsPerPage} // Set rows per page
                  paginationTotalRows={records.length} // Total number of records
                  paginationDefaultPage={currentPage} // Default starting page
                  onChangePage={(page) => setCurrentPage(page)} // Update current page
                  onChangeRowsPerPage={(newPerPage) =>
                    setRowsPerPage(newPerPage)
                  } // Update rows per page
                />
                <ToastContainer
                  position="top-center"
                  style={{ width: 'auto' }}
                />
              </div>
              <div className="text-end mt-2">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmitFacultyAssignments}
                >
                  Allocate
                </button>
              </div>
            </div>
          </div>
          <Tooltip id="my-tooltip" />
        </AdminLayout>
      </main>
      {/* // Modal for Editing Faculty Assignment */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Re Reassessment
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="faculty-select" className="col-form-label">
                  Reassessment Faculty:
                </label>
                <select
                  disabled
                  className="form-select "
                  value={rowReAssFacultyId || ''} // Track re-assessment faculty ID
                  onChange={(e) => setRowReAssFacultyId(e.target.value)} // Update selected re-assessment faculty
                >
                  <option value="">Select Faculty</option>
                  {Array.isArray(facultyList) && facultyList.length > 0 ? (
                    facultyList.map((faculty) => (
                      <option key={faculty.facultyId} value={faculty.facultyId}>
                        {faculty.facultyName}
                      </option>
                    ))
                  ) : (
                    <option>No faculty available</option>
                  )}
                </select>
              </div>

              <div className="mb-3">
                <label
                  htmlFor="additionalFaculty-select"
                  className="col-form-label"
                >
                  Select Re-Reassessment Faculty:
                </label>
                <select
                  className="form-select "
                  value={additionalFacultyId} // Track additional faculty ID
                  onChange={(e) => setAdditionalFacultyId(e.target.value)} // Update selected additional faculty
                >
                  <option value="">Select Additional Faculty</option>
                  {Array.isArray(facultyList) && facultyList.length > 0 ? (
                    facultyList.map((faculty) => (
                      <option key={faculty.facultyId} value={faculty.facultyId}>
                        {faculty.facultyName}
                      </option>
                    ))
                  ) : (
                    <option>No faculty available</option>
                  )}
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => closeReassessmentModal()}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={ReReassessment}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Adding New Reassessment */}
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="staticBackdropLabel">
                Add New Reassessment
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label htmlFor="subject-name" className="col-form-label">
                    Subject:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="subject-name"
                    value={subjectName}
                    disabled
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="rollNumber-select" className="col-form-label">
                    Select Roll Numbers:
                  </label>
                  <Select
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    placeholder="Select Roll Numbers"
                    isMulti
                    name="rollNumbers"
                    options={rollNumberOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={(selectedOptions) =>
                      handleChange(selectedOptions, { name: 'rollNumbers' })
                    }
                    value={rollNumberOptions.filter((option) =>
                      formData.rollNumbers.includes(option.value)
                    )}
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleAddReassessment}
              >
                Add Reassessment
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Modal */}
      <div
        className="modal fade"
        id="facultyModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Faculty Details
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {facultyData.length > 0 ? (
                <div className="container  ">
                  <div className="row justify-content-center">
                    {facultyData.map((faculty) => (
                      <div
                        key={faculty.id}
                        className="col-4 d-flex flex-column align-items-center mb-3 p-2  "
                        style={{ borderBottom: '1px solid #ddd' }}
                      >
                        <img
                          src="https://cdn-icons-png.freepik.com/512/16584/16584868.png?ga=GA1.1.1283962912.1697783763"
                          alt="Person Icon"
                          style={{
                            width: '50px',
                            height: '50px',
                            marginBottom: '8px',
                            cursor: 'pointer',
                          }}
                          onClick={() => handleImageClick(faculty.id)} // Add onClick to navigate with faculty ID
                        />
                        <span
                          className="text-primary fw-bold text-center"
                          style={{ fontSize: '1em' }}
                        >
                          {faculty.name}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <p className="text-muted">No faculty data available.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
